module.exports = __webpack_public_path__ + "img/bg12.b94cb6bd.jpg";